import Footer from './Footer';

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/Simulator/Footer/index.js